<template>
  <DeleteContact
    :confirm-message="$t('Are you sure you want to delete this recruiter?')"
    :confirm-button-text="$t('Yes, delete recruiter')"
    :on-confirm="runDeleteMutation"
    :show="show"
    @cancel="toggleModal"
  >
    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <WdsButtonText @click="toggleModal">
      {{ $t('Delete') }}
    </WdsButtonText>
  </DeleteContact>
</template>

<script>
import DeleteContact from '@/components/Contacts/DeleteContact.vue'
import { DeleteCompanyRecruiterMutation } from '@/components/Contacts/CompanyRecruiter/mutations/DeleteCompanyRecruiterMutation'
import { publicApi } from '@/app-bootstrapping/SetUpApollo'

export default {
  components: { DeleteContact },
  props: {
    companyRecruiterId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    show: false,
  }),
  methods: {
    async runDeleteMutation() {
      return publicApi
        .mutate({
          mutation: DeleteCompanyRecruiterMutation,
          variables: {
            input: {
              id: this.companyRecruiterId,
            },
          },
          options: {
            clientId: 'publicApi',
          },
        })
        .then((result) => {
          this.toggleModal()
          this.$emit('deleted')
          return result
        })
        .catch((error) => {
          throw error
        })
    },
    toggleModal() {
      this.show = !this.show
    },
  },
}
</script>
